import axiosInstance from "../server/axios";

export const fetchClientVentes = () => {
    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem('user'));
    return axiosInstance.get(`/venteclient/${user.id}`, {
       
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });
}

export const addClientVente = (data) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.post(`/ventes`, data, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    });
}

export const getVente = (id) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/ventes/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}

export const allMethodes = () => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/allMethodes`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
}
